
// 标的使用范围
export const addrOptions = [
  { label: '县内', value: '1' },
  { label: '县外', value: '2' },
]
// 交易方式
export const payOptions = [
  { label: '网络竞价', value: '1' },
  { label: '协议转让', value: '2' },
  { label: '预售', value: '3' },
]
// 林地属性
export const forestOptions = [
  { label: '国有', value: '1' },
  { label: '非国有', value: '2' },
]

// 拍卖状态
export const projectPropertiesOptions = [
  { label: '全部', value: '' },
  { label: '受让', value: '受让' },
  { label: '转让', value: '转让' },
  { label: '合股', value: '合股' },
  { label: '租赁', value: '租赁' },
  { label: '出租', value: '出租' },
  { label: '土地信托', value: '土地信托' },
  { label: '出售', value: '出售' },
  { label: '拍卖', value: '拍卖' }
]

//企业性质
export const companyPropertiesList = [
  {
    label: '国资监管机构/政府部门',
    id: 'A05001'
  },
  {
    label: '国有独资公司（企业）/国有全资企业',
    id: 'A05002'
  },
  {
    label: '国有控股企业',
    id: 'A05003'
  },
  {
    label: '国有事业单位，国有社团等',
    id: 'A05004'
  },
  {
    label: '国有及国有控股企业',
    id: 'A05005'
  },
  {
    label: '国有参股企业',
    id: 'A05006'
  },
  {
    label: '非国有企业',
    id: 'A05007'
  },
  {
    label: '外资企业',
    id: 'A05008'
  },
  {
    label: '其他',
    id: 'A05009'
  }
]

//企业类型
export const companyTypeList = [
  {
    label: '全民所有制企业',
    id: 'A19001'
  },
  {
    label: '有限责任公司',
    id: 'A19002'
  },
  {
    label: '股份有限公司',
    id: 'A19003'
  },
  {
    label: '集体所有制企业',
    id: 'A19004'
  },
  {
    label: '合伙企业',
    id: 'A19005'
  },
  {
    label: '其他',
    id: 'A19006'
  }
]

//经济规模
export const economicScaleList =  [
  {
    label: '大型',
    id: 'A04001'
  },
  {
    label: '中型',
    id: 'A04002'
  },
  {
    label: '小型',
    id: 'A04003'
  },
  {
    label: '微型',
    id: 'A04004'
  }
]

//资金来源
export const sourceFundList= [
  {
    label: '自有',
    id: '01'
  },
  {
    label: '融资',
    id: '02'
  },
  {
    label: '其他',
    id: '03'
  }
]
